/* eslint-disable react/jsx-pascal-case */
import React, { Component, useState } from 'react';
import { Col, Row, Label, Input, Button, FormText } from 'reactstrap';
import { Control, Form, Errors, actions } from 'react-redux-form';
import { checkHtmlTagAutoComplete } from '../utils/htmlTagAutoComplete';
import { handleArithmeticInput } from '../utils/arithmeticEval';
import { selectImageTagOnDoubleClick } from '../utils/imagePasteResize';

class Pro extends Component {
  constructor (props) {
    super(props);
    this.state = {
      inputDateFlag: '',
      inputPlaceFlag: '',
      inputPersonFlag: '',
      inputSubjectFlag: '',
      inputReasonFlag: '',
      inputCondition1Flag: '',
      inputCondition2Flag: '',
      inputCondition3Flag: '',
      inputCondition4Flag: '',
      inputCondition5Flag: '',
      inputCondition6Flag: '',
      inputCondition7Flag: '',
      inputCondition8Flag: '',
      inputCondition9Flag: '',
      inputCondition10Flag: '',
      inputCondition11Flag: '',
      inputCondition12Flag: '',
      inputCondition13Flag: '',
      inputCondition14Flag: '',
      inputCondition15Flag: '',
      inputCondition16Flag: '',
      inputCondition17Flag: '',
      inputCondition18Flag: '',
      inputCondition19Flag: '',
      inputCondition20Flag: '',
      inputDataFlag: '',
      inputUnitFlag: '',
      isLoaded: false
    };

    this.clearAllBoxes = this.clearAllBoxes.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.saveToStorage = this.saveToStorage.bind(this);
    this.loadFromStorage = this.loadFromStorage.bind(this);
  }

  async componentDidMount () {
    console.log(
      'Component mounted, props.dispatch available:',
      !!this.props.dispatch
    );
    await this.loadFromStorage();

    // Listen for row selection events to update X button visibility
    this._isMounted = true;
    this.handleRowSelected = (e) => {
      try {
        // Check if component is still mounted before updating state
        if (!this._isMounted) return;

        const { formData } = e.detail || {};
        if (formData) {
          this.setState({
            inputDateFlag: formData.date || '',
            inputPlaceFlag: formData.place || '',
            inputPersonFlag: formData.person || '',
            inputSubjectFlag: formData.subject || '',
            inputReasonFlag: formData.reason || '',
            inputCondition1Flag: formData.condition1 || '',
            inputCondition2Flag: formData.condition2 || '',
            inputCondition3Flag: formData.condition3 || '',
            inputCondition4Flag: formData.condition4 || '',
            inputCondition5Flag: formData.condition5 || '',
            inputCondition6Flag: formData.condition6 || '',
            inputCondition7Flag: formData.condition7 || '',
            inputCondition8Flag: formData.condition8 || '',
            inputCondition9Flag: formData.condition9 || '',
            inputCondition10Flag: formData.condition10 || '',
            inputCondition11Flag: formData.condition11 || '',
            inputCondition12Flag: formData.condition12 || '',
            inputCondition13Flag: formData.condition13 || '',
            inputCondition14Flag: formData.condition14 || '',
            inputCondition15Flag: formData.condition15 || '',
            inputCondition16Flag: formData.condition16 || '',
            inputCondition17Flag: formData.condition17 || '',
            inputCondition18Flag: formData.condition18 || '',
            inputCondition19Flag: formData.condition19 || '',
            inputCondition20Flag: formData.condition20 || '',
            inputDataFlag: formData.data || '',
            inputUnitFlag: formData.unit || ''
          });
        }
      } catch (err) {
        console.error('Error in handleRowSelected:', err);
      }
    };
    window.addEventListener('proFormRowSelected', this.handleRowSelected);
  }

  componentWillUnmount () {
    this._isMounted = false;
    if (this.handleRowSelected) {
      window.removeEventListener('proFormRowSelected', this.handleRowSelected);
    }
  }

  async loadFromStorage () {
    try {
      const savedDataString = localStorage.getItem('proDataForm');
      console.log('Storage result:', savedDataString);

      if (savedDataString) {
        const savedData = JSON.parse(savedDataString);
        console.log('Saved data:', savedData);

        this.setState({
          inputDateFlag: savedData.date || '',
          inputPlaceFlag: savedData.place || '',
          inputPersonFlag: savedData.person || '',
          inputSubjectFlag: savedData.subject || '',
          inputReasonFlag: savedData.reason || '',
          inputCondition1Flag: savedData.condition1 || '',
          inputCondition2Flag: savedData.condition2 || '',
          inputCondition3Flag: savedData.condition3 || '',
          inputCondition4Flag: savedData.condition4 || '',
          inputCondition5Flag: savedData.condition5 || '',
          inputCondition6Flag: savedData.condition6 || '',
          inputCondition7Flag: savedData.condition7 || '',
          inputCondition8Flag: savedData.condition8 || '',
          inputCondition9Flag: savedData.condition9 || '',
          inputCondition10Flag: savedData.condition10 || '',
          inputCondition11Flag: savedData.condition11 || '',
          inputCondition12Flag: savedData.condition12 || '',
          inputCondition13Flag: savedData.condition13 || '',
          inputCondition14Flag: savedData.condition14 || '',
          inputCondition15Flag: savedData.condition15 || '',
          inputCondition16Flag: savedData.condition16 || '',
          inputCondition17Flag: savedData.condition17 || '',
          inputCondition18Flag: savedData.condition18 || '',
          inputCondition19Flag: savedData.condition19 || '',
          inputCondition20Flag: savedData.condition20 || '',
          inputDataFlag: savedData.data || '',
          inputUnitFlag: savedData.unit || '',
          isLoaded: true
        });

        setTimeout(() => {
          console.log('Attempting to restore form data...');

          if (this.props.dispatch) {
            console.log('Using dispatch to update Redux store');
            this.props.dispatch(
              actions.change('proInput.date', savedData.date || '')
            );
            this.props.dispatch(
              actions.change('proInput.place', savedData.place || '')
            );
            this.props.dispatch(
              actions.change('proInput.person', savedData.person || '')
            );
            this.props.dispatch(
              actions.change('proInput.subject', savedData.subject || '')
            );
            this.props.dispatch(
              actions.change('proInput.reason', savedData.reason || '')
            );
            this.props.dispatch(
              actions.change('proInput.condition1', savedData.condition1 || '')
            );
            this.props.dispatch(
              actions.change('proInput.condition2', savedData.condition2 || '')
            );
            this.props.dispatch(
              actions.change('proInput.condition3', savedData.condition3 || '')
            );
            this.props.dispatch(
              actions.change('proInput.condition4', savedData.condition4 || '')
            );
            this.props.dispatch(
              actions.change('proInput.condition5', savedData.condition5 || '')
            );
            this.props.dispatch(
              actions.change('proInput.condition6', savedData.condition6 || '')
            );
            this.props.dispatch(
              actions.change('proInput.condition7', savedData.condition7 || '')
            );
            this.props.dispatch(
              actions.change('proInput.condition8', savedData.condition8 || '')
            );
            this.props.dispatch(
              actions.change('proInput.condition9', savedData.condition9 || '')
            );
            this.props.dispatch(
              actions.change(
                'proInput.condition10',
                savedData.condition10 || ''
              )
            );
            this.props.dispatch(
              actions.change(
                'proInput.condition11',
                savedData.condition11 || ''
              )
            );
            this.props.dispatch(
              actions.change(
                'proInput.condition12',
                savedData.condition12 || ''
              )
            );
            this.props.dispatch(
              actions.change(
                'proInput.condition13',
                savedData.condition13 || ''
              )
            );
            this.props.dispatch(
              actions.change(
                'proInput.condition14',
                savedData.condition14 || ''
              )
            );
            this.props.dispatch(
              actions.change(
                'proInput.condition15',
                savedData.condition15 || ''
              )
            );
            this.props.dispatch(
              actions.change(
                'proInput.condition16',
                savedData.condition16 || ''
              )
            );
            this.props.dispatch(
              actions.change(
                'proInput.condition17',
                savedData.condition17 || ''
              )
            );
            this.props.dispatch(
              actions.change(
                'proInput.condition18',
                savedData.condition18 || ''
              )
            );
            this.props.dispatch(
              actions.change(
                'proInput.condition19',
                savedData.condition19 || ''
              )
            );
            this.props.dispatch(
              actions.change(
                'proInput.condition20',
                savedData.condition20 || ''
              )
            );
            this.props.dispatch(
              actions.change('proInput.data', savedData.data || '')
            );
            this.props.dispatch(
              actions.change('proInput.unit', savedData.unit || '')
            );
          } else {
            console.log('No dispatch available!');
          }

          const fields = [
            'date',
            'place',
            'person',
            'subject',
            'reason',
            'condition1',
            'condition2',
            'condition3',
            'condition4',
            'condition5',
            'condition6',
            'condition7',
            'condition8',
            'condition9',
            'condition10',
            'condition11',
            'condition12',
            'condition13',
            'condition14',
            'condition15',
            'condition16',
            'condition17',
            'condition18',
            'condition19',
            'condition20',
            'data',
            'unit'
          ];
          fields.forEach(field => {
            const element = document.getElementById(field);
            if (element && savedData[field]) {
              console.log(`Setting ${field} to:`, savedData[field]);
              element.value = savedData[field];

              const events = ['input', 'change', 'blur'];
              events.forEach(eventType => {
                const event = new Event(eventType, { bubbles: true });
                element.dispatchEvent(event);
              });
            }
          });
          console.log('Form restoration complete');
        }, 200);
      } else {
        console.log('No saved data found in storage');
        this.setState({ isLoaded: true });
      }
    } catch (error) {
      console.log('Error loading from storage:', error);
      this.setState({ isLoaded: true });
    }
  }

  // Handle HTML tag auto-completion for reason field
  handleTagAutoComplete (e, flagName) {
    const textarea = e.target;
    const value = textarea.value;
    const cursorPos = textarea.selectionStart;

    // Set the flag first
    this.setState({ [flagName]: value }, () => this.saveToStorage());

    // Check for arithmetic evaluation (e.g. "1+1=" -> "2")
    handleArithmeticInput(textarea, value, (newVal) => {
      textarea.value = newVal;
      const inputEvent = new Event('input', { bubbles: true });
      textarea.dispatchEvent(inputEvent);
      this.setState({ [flagName]: newVal }, () => this.saveToStorage());
    });

    // Check for auto-completion
    const result = checkHtmlTagAutoComplete(value, cursorPos);
    if (result) {
      // Update the textarea value directly
      textarea.value = result.newValue;
      // Trigger change event for react-redux-form
      const event = new Event('input', { bubbles: true });
      textarea.dispatchEvent(event);
      // Set cursor position
      setTimeout(() => {
        textarea.selectionStart = result.cursorPos;
        textarea.selectionEnd = result.cursorPos;
        textarea.focus();
      }, 0);
      // Update flag with new value
      this.setState({ [flagName]: result.newValue }, () => this.saveToStorage());
    }
  }

  async saveToStorage () {
    const formData = {
      date: this.state.inputDateFlag,
      place: this.state.inputPlaceFlag,
      person: this.state.inputPersonFlag,
      subject: this.state.inputSubjectFlag,
      reason: this.state.inputReasonFlag,
      condition1: this.state.inputCondition1Flag,
      condition2: this.state.inputCondition2Flag,
      condition3: this.state.inputCondition3Flag,
      condition4: this.state.inputCondition4Flag,
      condition5: this.state.inputCondition5Flag,
      condition6: this.state.inputCondition6Flag,
      condition7: this.state.inputCondition7Flag,
      condition8: this.state.inputCondition8Flag,
      condition9: this.state.inputCondition9Flag,
      condition10: this.state.inputCondition10Flag,
      condition11: this.state.inputCondition11Flag,
      condition12: this.state.inputCondition12Flag,
      condition13: this.state.inputCondition13Flag,
      condition14: this.state.inputCondition14Flag,
      condition15: this.state.inputCondition15Flag,
      condition16: this.state.inputCondition16Flag,
      condition17: this.state.inputCondition17Flag,
      condition18: this.state.inputCondition18Flag,
      condition19: this.state.inputCondition19Flag,
      condition20: this.state.inputCondition20Flag,
      data: this.state.inputDataFlag,
      unit: this.state.inputUnitFlag
    };

    try {
      localStorage.setItem('proDataForm', JSON.stringify(formData));
      console.log('Saved to localStorage:', formData);
    } catch (error) {
      console.error('Error saving to storage:', error);
    }
  }

  clearAllBoxes () {
    this.setState({
      inputDateFlag: '',
      inputPlaceFlag: '',
      inputPersonFlag: '',
      inputSubjectFlag: '',
      inputReasonFlag: '',
      inputCondition1Flag: '',
      inputCondition2Flag: '',
      inputCondition3Flag: '',
      inputCondition4Flag: '',
      inputCondition5Flag: '',
      inputCondition6Flag: '',
      inputCondition7Flag: '',
      inputCondition8Flag: '',
      inputCondition9Flag: '',
      inputCondition10Flag: '',
      inputCondition11Flag: '',
      inputCondition12Flag: '',
      inputCondition13Flag: '',
      inputCondition14Flag: '',
      inputCondition15Flag: '',
      inputCondition16Flag: '',
      inputCondition17Flag: '',
      inputCondition18Flag: '',
      inputCondition19Flag: '',
      inputCondition20Flag: '',
      inputDataFlag: '',
      inputUnitFlag: ''
    });

    try {
      localStorage.removeItem('proDataForm');
      console.log('Cleared localStorage');
    } catch (error) {
      console.error('Error clearing storage:', error);
    }

    this.props.resetProInputForm();
  }

  handleSubmit = value => {
    this.props.postProInput(
      value.date,
      value.place,
      value.person,
      value.subject,
      value.reason,
      value.condition1,
      value.condition2,
      value.condition3,
      value.condition4,
      value.condition5,
      value.condition6,
      value.condition7,
      value.condition8,
      value.condition9,
      value.condition10,
      value.condition11,
      value.condition12,
      value.condition13,
      value.condition14,
      value.condition15,
      value.condition16,
      value.condition17,
      value.condition18,
      value.condition19,
      value.condition20,
      value.data,
      value.unit
    );

    try {
      localStorage.removeItem('proDataForm');
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }

    this.setState({
      inputDateFlag: '',
      inputPlaceFlag: '',
      inputPersonFlag: '',
      inputSubjectFlag: '',
      inputReasonFlag: '',
      inputCondition1Flag: '',
      inputCondition2Flag: '',
      inputCondition3Flag: '',
      inputCondition4Flag: '',
      inputCondition5Flag: '',
      inputCondition6Flag: '',
      inputCondition7Flag: '',
      inputCondition8Flag: '',
      inputCondition9Flag: '',
      inputCondition10Flag: '',
      inputCondition11Flag: '',
      inputCondition12Flag: '',
      inputCondition13Flag: '',
      inputCondition14Flag: '',
      inputCondition15Flag: '',
      inputCondition16Flag: '',
      inputCondition17Flag: '',
      inputCondition18Flag: '',
      inputCondition19Flag: '',
      inputCondition20Flag: '',
      inputDataFlag: '',
      inputUnitFlag: ''
    });

    this.props.resetProInputForm();
  };

  render () {
    if (!this.state.isLoaded) {
      return <div className='container main'>Loading...</div>;
    }

    return (
      <div className='container main'>
        <div className='row'>
          <div className='mb-2 col-12'>
            <h1 style={{ fontWeight: 500, display: 'flex', alignItems: 'center', gap: '12px' }}>
              Pro
              <span
                style={{
                  background: '#EEEDFE',
                  color: '#3C3489',
                  fontSize: '11px',
                  fontWeight: 500,
                  padding: '3px 8px',
                  borderRadius: '4px'
                }}
              >
                Experimental
              </span>
              {this.props.inputCount !== undefined && (
                <span style={{ fontSize: '14px', color: '#999', fontWeight: 400, marginLeft: 'auto' }}>
                  {this.props.inputCount} items
                </span>
              )}
            </h1>
          </div>
        </div>

        <p>
          Take any engineering data, create datasets for data science or machine
          learning{' '}
        </p>
        <Form model='proInput' onSubmit={value => this.handleSubmit(value)}>
          <Row className='form-group mb-3'>
            <Col sm={12}>
              <div style={{ position: 'relative' }}>
                <Control.text
                  model='.date'
                  id='date'
                  name='date'
                  className='form-control'
                  style={{
                    paddingRight: '30px',
                    paddingTop: this.state.inputDateFlag ? '20px' : '12px',
                    paddingBottom: this.state.inputDateFlag ? '6px' : '12px',
                    height: 'auto',
                    minHeight: '48px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e =>
                    this.setState({ inputDateFlag: e.target.value }, () =>
                      this.saveToStorage()
                    )
                  }
                />
                <label
                  htmlFor='date'
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: this.state.inputDateFlag ? '6px' : '50%',
                    transform: this.state.inputDateFlag ? 'none' : 'translateY(-50%)',
                    fontSize: this.state.inputDateFlag ? '10px' : '14px',
                    fontWeight: this.state.inputDateFlag ? '500' : '400',
                    textTransform: this.state.inputDateFlag ? 'uppercase' : 'none',
                    color: this.state.inputDateFlag ? '#666' : '#999',
                    transition: 'all 0.2s ease',
                    pointerEvents: 'none'
                  }}
                >
                  Date
                </label>
                {this.state.inputDateFlag && (
                  <button
                    type='button'
                    onClick={() => {
                      this.setState({ inputDateFlag: '' }, () =>
                        this.saveToStorage()
                      );
                      document.getElementById('date').value = '';
                      if (this.props.dispatch) {
                        this.props.dispatch(
                          actions.change('proInput.date', '')
                        );
                      }
                      const event = new Event('change', { bubbles: true });
                      document.getElementById('date').dispatchEvent(event);
                    }}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '10px',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'transparent',
                      border: 'none',
                      color: '#ccc',
                      cursor: 'pointer'
                    }}
                  >
                    X
                  </button>
                )}
              </div>
            </Col>
          </Row>
          <Row className='form-group mb-3'>
            <Col sm={12}>
              <div style={{ position: 'relative' }}>
                <Control.text
                  model='.place'
                  id='place'
                  name='place'
                  className='form-control'
                  style={{
                    paddingRight: '30px',
                    paddingTop: this.state.inputPlaceFlag ? '20px' : '12px',
                    paddingBottom: this.state.inputPlaceFlag ? '6px' : '12px',
                    height: 'auto',
                    minHeight: '48px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e =>
                    this.setState({ inputPlaceFlag: e.target.value }, () =>
                      this.saveToStorage()
                    )
                  }
                />
                <label
                  htmlFor='place'
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: this.state.inputPlaceFlag ? '6px' : '50%',
                    transform: this.state.inputPlaceFlag ? 'none' : 'translateY(-50%)',
                    fontSize: this.state.inputPlaceFlag ? '10px' : '14px',
                    fontWeight: this.state.inputPlaceFlag ? '500' : '400',
                    textTransform: this.state.inputPlaceFlag ? 'uppercase' : 'none',
                    color: this.state.inputPlaceFlag ? '#666' : '#999',
                    transition: 'all 0.2s ease',
                    pointerEvents: 'none'
                  }}
                >
                  Place
                </label>
                {this.state.inputPlaceFlag && (
                  <button
                    type='button'
                    onClick={() => {
                      this.setState({ inputPlaceFlag: '' }, () =>
                        this.saveToStorage()
                      );
                      document.getElementById('place').value = '';
                      if (this.props.dispatch) {
                        this.props.dispatch(
                          actions.change('proInput.place', '')
                        );
                      }
                      const event = new Event('change', { bubbles: true });
                      document.getElementById('place').dispatchEvent(event);
                    }}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '10px',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'transparent',
                      border: 'none',
                      color: '#ccc',
                      cursor: 'pointer'
                    }}
                  >
                    X
                  </button>
                )}
              </div>
            </Col>
          </Row>
          <Row className='form-group mb-3'>
            <Col sm={12}>
              <div style={{ position: 'relative' }}>
                <Control.text
                  model='.person'
                  id='person'
                  name='person'
                  className='form-control'
                  style={{
                    paddingRight: '30px',
                    paddingTop: this.state.inputPersonFlag ? '20px' : '12px',
                    paddingBottom: this.state.inputPersonFlag ? '6px' : '12px',
                    height: 'auto',
                    minHeight: '48px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e =>
                    this.setState({ inputPersonFlag: e.target.value }, () =>
                      this.saveToStorage()
                    )
                  }
                />
                <label
                  htmlFor='person'
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: this.state.inputPersonFlag ? '6px' : '50%',
                    transform: this.state.inputPersonFlag ? 'none' : 'translateY(-50%)',
                    fontSize: this.state.inputPersonFlag ? '10px' : '14px',
                    fontWeight: this.state.inputPersonFlag ? '500' : '400',
                    textTransform: this.state.inputPersonFlag ? 'uppercase' : 'none',
                    color: this.state.inputPersonFlag ? '#666' : '#999',
                    transition: 'all 0.2s ease',
                    pointerEvents: 'none'
                  }}
                >
                  Person
                </label>
                {this.state.inputPersonFlag && (
                  <button
                    type='button'
                    onClick={() => {
                      this.setState({ inputPersonFlag: '' }, () =>
                        this.saveToStorage()
                      );
                      document.getElementById('person').value = '';
                      if (this.props.dispatch) {
                        this.props.dispatch(
                          actions.change('proInput.person', '')
                        );
                      }
                      const event = new Event('change', { bubbles: true });
                      document.getElementById('person').dispatchEvent(event);
                    }}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '10px',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'transparent',
                      border: 'none',
                      color: '#ccc',
                      cursor: 'pointer'
                    }}
                  >
                    X
                  </button>
                )}
              </div>
            </Col>
          </Row>
          <Row className='form-group mb-3'>
            <Col sm={12}>
              <div style={{ position: 'relative' }}>
                <Control.text
                  model='.subject'
                  id='subject'
                  name='subject'
                  className='form-control'
                  style={{
                    paddingRight: '30px',
                    paddingTop: this.state.inputSubjectFlag ? '20px' : '12px',
                    paddingBottom: this.state.inputSubjectFlag ? '6px' : '12px',
                    height: 'auto',
                    minHeight: '48px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e =>
                    this.setState({ inputSubjectFlag: e.target.value }, () =>
                      this.saveToStorage()
                    )
                  }
                />
                <label
                  htmlFor='subject'
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: this.state.inputSubjectFlag ? '6px' : '50%',
                    transform: this.state.inputSubjectFlag ? 'none' : 'translateY(-50%)',
                    fontSize: this.state.inputSubjectFlag ? '10px' : '14px',
                    fontWeight: this.state.inputSubjectFlag ? '500' : '400',
                    textTransform: this.state.inputSubjectFlag ? 'uppercase' : 'none',
                    color: this.state.inputSubjectFlag ? '#666' : '#999',
                    transition: 'all 0.2s ease',
                    pointerEvents: 'none'
                  }}
                >
                  Subject
                </label>
                {this.state.inputSubjectFlag && (
                  <button
                    type='button'
                    onClick={() => {
                      this.setState({ inputSubjectFlag: '' }, () =>
                        this.saveToStorage()
                      );
                      document.getElementById('subject').value = '';
                      if (this.props.dispatch) {
                        this.props.dispatch(
                          actions.change('proInput.subject', '')
                        );
                      }
                      const event = new Event('change', { bubbles: true });
                      document.getElementById('subject').dispatchEvent(event);
                    }}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '10px',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'transparent',
                      border: 'none',
                      color: '#ccc',
                      cursor: 'pointer'
                    }}
                  >
                    X
                  </button>
                )}
              </div>
            </Col>
          </Row>
          <Row className='form-group mb-3'>
            <Col sm={12}>
              <div style={{ position: 'relative' }}>
                <Control.textarea
                  model='.reason'
                  id='reason'
                  name='reason'
                  className='form-control'
                  rows={3}
                  style={{
                    paddingTop: this.state.inputReasonFlag ? '24px' : '12px',
                    paddingBottom: '8px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    transition: 'all 0.2s ease',
                    resize: 'vertical'
                  }}
                  onChange={e => this.handleTagAutoComplete(e, 'inputReasonFlag')}
                  onDoubleClick={selectImageTagOnDoubleClick}
                />
                <label
                  htmlFor='reason'
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: this.state.inputReasonFlag ? '6px' : '12px',
                    fontSize: this.state.inputReasonFlag ? '10px' : '14px',
                    fontWeight: this.state.inputReasonFlag ? '500' : '400',
                    textTransform: this.state.inputReasonFlag ? 'uppercase' : 'none',
                    color: this.state.inputReasonFlag ? '#666' : '#999',
                    transition: 'all 0.2s ease',
                    pointerEvents: 'none'
                  }}
                >
                  Reason
                </label>
              </div>
            </Col>
          </Row>
          <Row className='form-group mb-3'>
            <Col sm={12}>
              <label style={{ fontSize: '10px', fontWeight: 500, textTransform: 'uppercase', color: '#666', marginBottom: '8px', display: 'block' }}>
                Condition
              </label>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '8px' }}>
                <Control.text
                  htmlFor='condition1'
                  model='.condition1'
                  type='text'
                  id='condition1'
                  name='condition1'
                  placeholder='1'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition1Flag);
                    this.setState({ inputCondition1Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition2'
                  model='.condition2'
                  type='text'
                  id='condition2'
                  name='condition2'
                  placeholder='2'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition2Flag);
                    this.setState({ inputCondition2Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition3'
                  model='.condition3'
                  type='text'
                  id='condition3'
                  name='condition3'
                  placeholder='3'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition3Flag);
                    this.setState({ inputCondition3Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition4'
                  model='.condition4'
                  type='text'
                  id='condition4'
                  name='condition4'
                  placeholder='4'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition4Flag);
                    this.setState({ inputCondition4Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition5'
                  model='.condition5'
                  type='text'
                  id='condition5'
                  name='condition5'
                  placeholder='5'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition5Flag);
                    this.setState({ inputCondition5Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
              </div>
            </Col>
          </Row>

          <Row className='form-group mb-3'>
            <Col sm={12}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '8px' }}>
                <Control.text
                  htmlFor='condition6'
                  model='.condition6'
                  type='text'
                  id='condition6'
                  name='condition6'
                  placeholder='6'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition6Flag);
                    this.setState({ inputCondition6Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition7'
                  model='.condition7'
                  type='text'
                  id='condition7'
                  name='condition7'
                  placeholder='7'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition7Flag);
                    this.setState({ inputCondition7Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition8'
                  model='.condition8'
                  type='text'
                  id='condition8'
                  name='condition8'
                  placeholder='8'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition8Flag);
                    this.setState({ inputCondition8Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition9'
                  model='.condition9'
                  type='text'
                  id='condition9'
                  name='condition9'
                  placeholder='9'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition9Flag);
                    this.setState({ inputCondition9Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition10'
                  model='.condition10'
                  type='text'
                  id='condition10'
                  name='condition10'
                  placeholder='10'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition10Flag);
                    this.setState({ inputCondition10Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
              </div>
            </Col>
          </Row>

          <Row className='form-group mb-3'>
            <Col sm={12}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '8px' }}>
                <Control.text
                  htmlFor='condition11'
                  model='.condition11'
                  type='text'
                  id='condition11'
                  name='condition11'
                  placeholder='11'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition11Flag);
                    this.setState({ inputCondition11Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition12'
                  model='.condition12'
                  type='text'
                  id='condition12'
                  name='condition12'
                  placeholder='12'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition12Flag);
                    this.setState({ inputCondition12Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition13'
                  model='.condition13'
                  type='text'
                  id='condition13'
                  name='condition13'
                  placeholder='13'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition13Flag);
                    this.setState({ inputCondition13Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition14'
                  model='.condition14'
                  type='text'
                  id='condition14'
                  name='condition14'
                  placeholder='14'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition14Flag);
                    this.setState({ inputCondition14Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition15'
                  model='.condition15'
                  type='text'
                  id='condition15'
                  name='condition15'
                  placeholder='15'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition15Flag);
                    this.setState({ inputCondition15Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
              </div>
            </Col>
          </Row>

          <Row className='form-group mb-3'>
            <Col sm={12}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '8px' }}>
                <Control.text
                  htmlFor='condition16'
                  model='.condition16'
                  type='text'
                  id='condition16'
                  name='condition16'
                  placeholder='16'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition16Flag);
                    this.setState({ inputCondition16Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition17'
                  model='.condition17'
                  type='text'
                  id='condition17'
                  name='condition17'
                  placeholder='17'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition17Flag);
                    this.setState({ inputCondition17Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition18'
                  model='.condition18'
                  type='text'
                  id='condition18'
                  name='condition18'
                  placeholder='18'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition18Flag);
                    this.setState({ inputCondition18Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition19'
                  model='.condition19'
                  type='text'
                  id='condition19'
                  name='condition19'
                  placeholder='19'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition19Flag);
                    this.setState({ inputCondition19Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
                <Control.text
                  htmlFor='condition20'
                  model='.condition20'
                  type='text'
                  id='condition20'
                  name='condition20'
                  placeholder='20'
                  className='form-control'
                  style={{
                    background: '#f5f5f5',
                    color: '#333',
                    fontWeight: 400,
                    border: 'none',
                    borderRadius: '6px',
                    textAlign: 'center',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e => {
                    handleArithmeticInput(e.target, e.target.value, (newVal) => {
                      e.target.value = newVal;
                      e.target.dispatchEvent(new Event('input', { bubbles: true }));
                    }, this.state.inputCondition20Flag);
                    this.setState({ inputCondition20Flag: e.target.value }, () =>
                      this.saveToStorage()
                    );
                  }}
                />
              </div>
            </Col>
          </Row>

          <Row className='form-group mb-3'>
            <Col xs={6}>
              <div style={{ position: 'relative' }}>
                <Control.text
                  model='.data'
                  id='data'
                  name='data'
                  className='form-control'
                  style={{
                    paddingRight: '30px',
                    paddingTop: this.state.inputDataFlag ? '20px' : '12px',
                    paddingBottom: this.state.inputDataFlag ? '6px' : '12px',
                    height: 'auto',
                    minHeight: '48px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e =>
                    this.setState({ inputDataFlag: e.target.value }, () =>
                      this.saveToStorage()
                    )
                  }
                />
                <label
                  htmlFor='data'
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: this.state.inputDataFlag ? '6px' : '50%',
                    transform: this.state.inputDataFlag ? 'none' : 'translateY(-50%)',
                    fontSize: this.state.inputDataFlag ? '10px' : '14px',
                    fontWeight: this.state.inputDataFlag ? '500' : '400',
                    textTransform: this.state.inputDataFlag ? 'uppercase' : 'none',
                    color: this.state.inputDataFlag ? '#666' : '#999',
                    transition: 'all 0.2s ease',
                    pointerEvents: 'none'
                  }}
                >
                  Data
                </label>
                {this.state.inputDataFlag && (
                  <button
                    type='button'
                    onClick={() => {
                      this.setState({ inputDataFlag: '' }, () =>
                        this.saveToStorage()
                      );
                      document.getElementById('data').value = '';
                      if (this.props.dispatch) {
                        this.props.dispatch(
                          actions.change('proInput.data', '')
                        );
                      }
                      const event = new Event('change', { bubbles: true });
                      document.getElementById('data').dispatchEvent(event);
                    }}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '10px',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'transparent',
                      border: 'none',
                      color: '#ccc',
                      cursor: 'pointer'
                    }}
                  >
                    X
                  </button>
                )}
              </div>
            </Col>
            <Col xs={6}>
              <div style={{ position: 'relative' }}>
                <Control.text
                  model='.unit'
                  id='unit'
                  name='unit'
                  className='form-control'
                  style={{
                    paddingRight: '30px',
                    paddingTop: this.state.inputUnitFlag ? '20px' : '12px',
                    paddingBottom: this.state.inputUnitFlag ? '6px' : '12px',
                    height: 'auto',
                    minHeight: '48px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    transition: 'all 0.2s ease'
                  }}
                  onChange={e =>
                    this.setState({ inputUnitFlag: e.target.value }, () =>
                      this.saveToStorage()
                    )
                  }
                />
                <label
                  htmlFor='unit'
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: this.state.inputUnitFlag ? '6px' : '50%',
                    transform: this.state.inputUnitFlag ? 'none' : 'translateY(-50%)',
                    fontSize: this.state.inputUnitFlag ? '10px' : '14px',
                    fontWeight: this.state.inputUnitFlag ? '500' : '400',
                    textTransform: this.state.inputUnitFlag ? 'uppercase' : 'none',
                    color: this.state.inputUnitFlag ? '#666' : '#999',
                    transition: 'all 0.2s ease',
                    pointerEvents: 'none'
                  }}
                >
                  Unit
                </label>
                {this.state.inputUnitFlag && (
                  <button
                    type='button'
                    onClick={() => {
                      this.setState({ inputUnitFlag: '' }, () =>
                        this.saveToStorage()
                      );
                      document.getElementById('unit').value = '';
                      if (this.props.dispatch) {
                        this.props.dispatch(
                          actions.change('proInput.unit', '')
                        );
                      }
                      const event = new Event('change', { bubbles: true });
                      document.getElementById('unit').dispatchEvent(event);
                    }}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '10px',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'transparent',
                      border: 'none',
                      color: '#ccc',
                      cursor: 'pointer'
                    }}
                  >
                    X
                  </button>
                )}
              </div>
            </Col>
          </Row>
          <Row className='form-group mt-4'>
            <Col sm={12} style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
              <Button
                type='button'
                onClick={this.clearAllBoxes}
                style={{
                  background: 'transparent',
                  border: '1px solid #ddd',
                  color: '#666',
                  borderRadius: '8px',
                  padding: '10px 24px',
                  fontWeight: 500
                }}
              >
                Clear
              </Button>
              <Button
                type='submit'
                disabled={this.props.isUpdating}
                style={{
                  background: '#185FA5',
                  border: 'none',
                  color: '#fff',
                  borderRadius: '8px',
                  padding: '10px 24px',
                  fontWeight: 500
                }}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

export default Pro;
